import request from '@/utils/request'

/**
 * 搜索详情列表
 * @param {*} params
 */
export function getProjectNodeList(params) {
  return request({
    url: '/bsProjectNode',
    method: 'get',
    params: params
  })
}
/**
 * 添加
 * @param {*} params
 */
export function addProjectNode(params) {
  return request({
    url: '/bsProjectNode',
    method: 'post',
    data: params
  })
}
/**
 * 修改
 * @param {*} params
 */
export function editProjectNode(params) {
  return request({
    url: '/bsProjectNode',
    method: 'put',
    data: params
  })
}
/**
 * 通过id删除
 */
export function deleteProjectNode(id) {
    return request({
      url: `/bsProjectNode/${id}`,
      method: 'delete',
    })
  }
  /**
   * 查看详情
   */
  export function getProjectNodeInfo(id) {
    return request({
      url: `/bsProjectNode/${id}`,
      method: 'get'
    })
  }